import React from 'react';

import { ServiceNowForm } from './ServiceNowForm';

interface Props {
  onSubmit: (data) => void;
}

export const EditServicenow = (props: Props) => {
  return (
    <ServiceNowForm
      handleSubmit={props.onSubmit}
      validate
      actionType="Update"
    />
  );
};
